import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AgGridModule } from 'ag-grid-angular';

import { RelationshipTreeComponent } from './relationship-tree/relationship-tree.component';
import { WidgetsModule } from '../widgets/widgets.module';
import { LayoutComponent } from './layout/layout.component';
import { FinderComponent } from './finder/finder.component';
import { SnippetThreadListComponent } from './snippet-thread-list/snippet-thread-list.component';
import { TopThreadListComponent } from './top-thread-list/top-thread-list.component';
import { ResearchScreenComponent } from './research-screen/research-screen.component';
import { ThreadDetailModule } from './thread-detail/thread-detail.module';
import { ResearchRefinebyComponent } from './research-refineby/research-refineby.component';
import { SnippetThreadListItemModule } from './snippet-thread-list-item/snippet-thread-list-item.module';
import { SortModule } from './sort/sort.module';
import { ResearchLayoutModule } from './research-layout/research-layout.module';
import { DialogModule } from '@progress/kendo-angular-dialog';

import { DisplayComponent } from './display/display.component';
import { AsyncGroupPagingGridComponent } from './top-thread-list/async-group-paging-grid/async-group-paging-grid.component';
import { ServerSideGridPinnedRowComponent } from './top-thread-list/async-group-paging-grid/custom-grid-pinned-row/custom-pinned-row-render.component';
import { ExchangePanelComponent } from './exchange/exchange-panel/exchange-panel.component';
import { ExchangeSyncContactComponent } from './exchange/exchange-sync-contact/exchange-sync-contact.component';
import { MapTileDialogModule } from './map-tile-dialog/map-tile-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        // kendo
        DropDownButtonModule,
        DropDownsModule,
        TooltipModule,
        TreeViewModule,
        DialogModule,
        // other 3rd party
        AgGridModule,
        InfiniteScrollModule,
        // project
        ThreadDetailModule,
        WidgetsModule,
        SnippetThreadListItemModule,
        SortModule,
        ResearchLayoutModule,
        MapTileDialogModule
    ],
    declarations: [
        FinderComponent,
        LayoutComponent,
        RelationshipTreeComponent,
        ResearchRefinebyComponent,
        ResearchScreenComponent,
        SnippetThreadListComponent,
        TopThreadListComponent,
        DisplayComponent,
        AsyncGroupPagingGridComponent,
        ServerSideGridPinnedRowComponent,
        ExchangePanelComponent,
        ExchangeSyncContactComponent,
    ],
    exports: [
        FinderComponent,
        LayoutComponent,
        RelationshipTreeComponent,
        ResearchRefinebyComponent,
        ResearchScreenComponent,
        SnippetThreadListComponent,
        TopThreadListComponent,
    ]
})
export class ResearchComponentModule { }
